import { type TFunction } from 'i18next';
import { amountBlock, firstBlock, NorwegianApplicant, NorwegianLoanApplication, secondBlock, thirdBlock } from './fieldDefinitions';
import { AccomodationStatusValue,  MartialStatusValues } from '@n2-common/uiFieldValues/applicationFormFields';

export function getTranslatedStages(t: TFunction) {
    return [
        amountBlock(t),
        firstBlock(t),
        secondBlock(t),
        thirdBlock(t), 
    ];
}

export function cleanupFormValuesForSubmitting(values: NorwegianLoanApplication): NorwegianLoanApplication {
    const retVal: NorwegianLoanApplication = {
        ...values,
        Applicant: getCleanedApplicantDataWithNulledHiddenFields(values.Applicant)
    };
    return retVal;
}

function getCleanedApplicantDataWithNulledHiddenFields(applicant: NorwegianApplicant): NorwegianApplicant {
    return {
        ...applicant,
        AccommodationTypeOther: specifyAccommodationTypeOther(applicant?.AccommodationType as AccomodationStatusValue) 
        ? applicant.AccommodationTypeOther : '',
        AccommodationCost: specifyAccomodationCost(applicant?.AccommodationType as AccomodationStatusValue) ? applicant.AccommodationCost : '',
        PartnerIncome: applicantHasSharedEconomy(applicant.MaritalStatus) ? applicant.PartnerIncome : null
     //   StudentLoanMontlyCost: specifyStudenLoanPayment(applicant) ? applicant.StudentLoanMontlyCost : '',
       // NationalId: cleanupSwedishNationalId(applicant.NationalId),
    };
}

export function specifyAccommodationTypeOther(accommodationType: AccomodationStatusValue | '' | null | undefined) {
    if (!accommodationType || accommodationType === null) {
        return false;
    }
    return accommodationType === 'O';
}

export function specifyAccomodationCost(accommodationType: AccomodationStatusValue | '' | null | undefined) {
    if (accommodationType === '' || !accommodationType || accommodationType === null) {
        return false;
    }
    return accommodationType !== 'H';
}

export function applicantHasSharedEconomy(martialStatus: MartialStatusValues | '' | null | undefined) {
    if (!martialStatus || martialStatus === null) {
        return false;
    }
    return martialStatus === 'C' || martialStatus === 'M';
}
